import axios, { AxiosResponse } from 'axios';

import { apiUrl } from '@/config/api';

import { ApiEventsList, PropertiesList } from './types/events';

const list = (data: PropertiesList, token: string): Promise<AxiosResponse<ApiEventsList>> => {
    return axios.post(
        `${apiUrl}/trk/tracking/device-event/detail/list/bydevice`,
        {
            deviceId: data.deviceId,
            from: data.date,
            /* until: '2021-07-03T07:54:23.161Z', */
        },
        {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        },
    );
};

export default {
    list,
};
